export default {
  es: {
    login: 'Ingresar',
    loginStaff: 'Iniciar sesión',
    select: 'Seleccione su tipo de usuario:',
    staff: 'Staff médico',
    patient: 'Paciente',
    welcome: 'Le damos la bienvenida a Nefroplus Renal Care Services',
    remember: 'Recuérdame',
    forgot: 'Olvidé mi contraseña',
    username: 'Usuario',
    docid: 'Documento de identidad',
    password: 'Contraseña',
    mfaTitle: 'Introducir código de verificación',
    mfaDetail:
      'Por favor verifica tu cuenta ingresando el código de 6 dígitos que te enviaremos.',
    mfaFactorTitle: 'Enviar código por:',
    mfaEmailTitle: 'E-mail',
    mfaEmailMessage: 'Se enviará al correo electrónico registrado ',
    mfaEmailNotificationBar: 'Ya no tengo acceso a este correo electrónico',
    mfaSmsTitle: 'SMS',
    mfaSmsMessage: 'Se enviará un mensaje de texto al número registrado ',
    mfaSmsNotificationBar: 'Ya no tengo este número telefónico',
    mfaCallTitle: 'Llamada',
    mfaCallMessage: 'Recibirás una llamada para que recibas el código ',
    mfaCallNotificationBar: 'Ya no tengo este número telefónico',
    mfaSubmitButton: 'Enviar código',
    mfaVerifyButton: 'Verificar código',
    mfaEnterCode:
      'Por favor ingresa el código de 6 dígitos que le fue enviado via ',
    mfaCodeExpire: 'Este código expirará en ',
    mfaCodeExpireMetric: ' Minutos',
    mfaNewCode: 'Solicitar un nuevo código',
    mfaChangeFactor: 'Usar otro método para recibir el código',
    mfaDataUpdate: 'Actualización de datos',
    mfaNavigateBack: 'Regresar',
    mfaCode: 'El código es requerido!',
    mfaContantAdmin:
      'Por favor póngase en contacto con su clínica para modificar los datos de registro.',
    vantiveNow:
      'Baxter Kidney Care ahora es Vantive, una compañía de atención médica especializada en terapias para órganos vitales. Visite Vantive.com para obtener más información. Vantive respetará las declaraciones de privacidad proporcionadas por Baxter para los datos personales recopilados y mantenidos por Baxter durante la transición de estos sitios web. Para obtener información sobre cómo Vantive procesa y protege su información personal, escríbanos a privacy@vantive.com'
  },
  en: {
    login: 'Login',
    loginStaff: 'Log in',
    select: 'Select user type:',
    staff: 'Medical staff',
    patient: 'Patient',
    welcome: 'We welcome you to Nefroplus Renal Care Services',
    remember: 'Remember me',
    forgot: 'Forgot my password',
    username: 'Username',
    docid: 'Identification document',
    password: 'Password',
    mfaTitle: 'Enter verification code',
    mfaDetail: 'Please enter the 6 digits that were sent',
    mfaFactorTitle: 'Send code by:',
    mfaEmailTitle: 'E-mail',
    mfaEmailMessage: '6 digits code will be sent to the registered email ',
    mfaEmailNotificationBar: 'I no longer have access to this email',
    mfaSmsTitle: 'SMS',
    mfaSmsMessage: 'A text message will be sent to the registered number ',
    mfaSmsNotificationBar: 'I no longer have this phone number',
    mfaCallTitle: 'Phone call',
    mfaCallMessage: 'You are going to receive a call.',
    mfaCallNotificationBar: 'I no longer have this phone number',
    mfaSubmitButton: 'Send Code',
    mfaVerifyButton: 'Verify code',
    mfaEnterCode: 'Please enter the 6 digits code that were sent by ',
    mfaCodeExpire: 'This code expires in ',
    mfaCodeExpireMetric: ' Minutes',
    mfaNewCode: 'Request new code',
    mfaChangeFactor: 'Select another method to receive the code',
    mfaDataUpdate: 'Update information.',
    mfaNavigateBack: 'Return',
    mfaCode: 'Code required',
    mfaContantAdmin:
      'Please contact your clinic to modify the registration data.',
    vantiveNow:
      'Baxter Kidney Care is now Vantive, a healthcare company focused on vital organ therapies. Visit Vantive.com to learn more. Vantive will honor Baxter-provided privacy statements for personal data collected and maintained by Baxter as these websites transition. For information about how Vantive processes and protects your personal information, please email us at privacy@vantive.com'
  }
};
